/**
 * 폼 헬퍼 — 셀렉트 채우기 · 입력 포맷 · 핸들러 등록
 *
 * 구 `public/js/common.js` 에서 옮겨온 DOM 조작 유틸. 값 계산만 하는 것은
 * `Common/Util` 에, 화면 요소를 직접 만지는 것은 여기에 둔다.
 *
 * 전역 이름(`registerPhoneHandler` 등)은 `legacy.entry.js` 가 위임으로 유지한다 —
 * blade 인라인·onclick 이 그 이름으로 부르기 때문이다.
 *
 * ⚠ jQuery(`$`)와 `G5`·`MEMBER` 전역에 기대는 메서드가 있다. 둘 다 이 번들보다
 *   먼저 실리는 것이 전제다 (vendor.js · /asset/bootstrap).
 */
import Util from './Util';

export default class Form {
    /**
     * <input> 의 값을 세자리 컴마 형식으로 다시 쓴다. (구 전역 `numbercommanmake`)
     * 기존 컴마를 먼저 털어내야 하므로 parseNumber→formatNumber 짝이 필요하다 —
     * `number_format(값)` 만으로는 '1,234' 가 1 로 읽혀서 안 된다.
     * @param el 입력 엘리먼트
     */
    static formatNumberInput(el) {
        el.value = Util.formatNumber(Util.parseNumber(el.value));
    }

    /**
     * 숫자 <input> 에 컴마 자동부여 핸들러를 건다. 붙여넣기·IME 도 잡도록 `input` 을 쓴다.
     * @param id 엘리먼트 id
     */
    static registerNumberHandler(id) {
        $('#' + id).on('input', function () { Form.formatNumberInput(this); });
    }

    /**
     * 전화번호 <input> 에 입력값 필터링 핸들러 적용
     * @param id
     */
    static registerPhoneHandler(id) {
        $('#'+id).on('input', function() {
            let num = Util.phoneNumber( $(this).val() );

            $(this).val(num);
        });
    }

    /**
     * 본사 selectbox 선택시 핸들러 등록
     * @param bid 본사selectbox id
     * @param gid 지사selectbox id
     * @param cid 센터selectbox id
     * @param func 추가핸들러
     */
    static registerBonsaHandler(bid,gid,cid,func=null) {
        $('#'+bid).change(function(){
            var sosok = $(`#${bid} option:selected`).val();

            Form.updateBonsaSelectBox(sosok, bid,gid,cid, func);
        });
    }

    /**
     * 지사 selectbox 선택시 핸들러 등록
     * @param gid
     * @param cid
     */
    static registerGisaHandler(gid,cid) {
        $('#'+gid).change(function(){
            var gsanum = $(`#${gid} option:selected`).val();

            Form.updateCenterSelectBox(gsanum,cid);
        });
    }

    /**
     * 본사 <select> 를 업데이트하면서 나머지 지사,센터도 차례차례 업데이트한다.
     * @param sosok 소속코드전체(본사코드만 아니고 지사,센터 모두 포함한 코드)
     * @param bid 본사 엘리먼트 id
     * @param gid
     * @param cid
     * @param func 추가핸들러
     */
    static updateBonsaSelectBox(sosok, bid, gid, cid, func) {
        console.log('updateBonsaSelectBox', sosok, bid,gid,cid);
        if(!sosok) sosok='';

        const bsanum = sosok.substring(0,3);
        let sel="";
        const url = "/ajax/sosok?m=bonsa";
        $.getJSON( url, function( data ) {
            $(`#${bid} option:not(:first)`).remove();
            $.each( data, function( key, val ) {
                sel=''; if( key==bsanum) sel='selected';
                $(`#${bid}`).append(`<option value="${key}" ${sel}>${val}</option>`);
            });
            // 지사 업데이트
            Form.updateGisaSelectBox(sosok,gid,cid);

            // 추가 핸들러
            if( func ) func(sosok);
        });
    }

    /**
     * 지사selectbox를 업데이트한다.
     * @param sosok 소속코드
     * @param gid 지사selectbox id
     */
    static updateGisaSelectBox(sosok, gid,cid) {
        console.log('updateGisaSelectBox', sosok, gid,cid);
        const gsanum = sosok.substring(0,6);
        let sel="";
        const url = "/ajax/sosok?m=gisa&sosok="+sosok;
        $.getJSON( url, function( data ) {
            $(`#${gid} option:not(:first)`).remove();
            $.each( data, function( key, val ) {
                sel=''; if( key==gsanum) sel='selected';
                $(`#${gid}`).append(`<option value="${key}" ${sel}>${val}</option>`);
            });
            // 센터 업데이트
            Form.updateCenterSelectBox(sosok,cid);
        });
    }

    /**
     * 센터selectbox를 업데이트한다.
     * @param sosok 소속코드
     * @param cid 센터selectbox id
     */
    static updateCenterSelectBox(sosok,cid) {
        const cntnum = sosok.substring(0,9);
        let sel="";
        let url = "/ajax/sosok?m=center&sosok="+sosok;
        $.getJSON( url, function( data ) {
            $(`#${cid} option:not(:first)`).remove();
            $.each( data, function( key, val ) {
                sel=''; if(key==cntnum)sel='selected';
                $(`#${cid}`).append('<option value="'+key+'" '+sel+'>'+val+'</option>');
            });
        });
    }
}
